import { render, staticRenderFns } from "./SharedAccountsModal.vue?vue&type=template&id=3b96bae8"
import script from "./SharedAccountsModal.vue?vue&type=script&lang=js"
export * from "./SharedAccountsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports